import { render, staticRenderFns } from "./PolicyModal.vue?vue&type=template&id=6e08e12e"
import script from "./PolicyModal.vue?vue&type=script&lang=js"
export * from "./PolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyModal.vue?vue&type=style&index=0&id=6e08e12e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports